import React from 'react';
import { Label } from '@logora/parliament.ui.label';
import { AssemblyIcon, SenateIcon } from '@logora/parliament.icons.regular_icons';
import cx from 'classnames';

interface ChamberLabelProps {
    /** Chamber name */
    chamber: string;
    /** Whether to show the short text of the chamber or not */
    short?: boolean;
    /** Extra classname */
    className?: string | undefined;
}

export const ChamberLabel = ({ chamber, short = false, className = undefined }: ChamberLabelProps) => {
    const lowerCaseChamber = chamber.toLowerCase()

    return (
        <>
            { lowerCaseChamber === "assemblee" || lowerCaseChamber === "an" ? (
                <Label
                    className={className}
                    text={short ? "AN" : "Assemblée"}
                    leftIcon={<AssemblyIcon height={20} width={20} />}
                />
            ) : lowerCaseChamber === "senat" || lowerCaseChamber === "sn" ? (
                <Label
                    className={className}
                    text={short ? "SN" : "Sénat"}
                    leftIcon={<SenateIcon height={20} width={20} />}
                />
            ) : null}
        </>
    );
};